var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBxsBank(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.47327 10V15.0013H4.72327V22.5H3.47327V26.25H23.4733L27.2233 26.2512V26.25H28.4733V22.5H27.2233V15.0013H28.4733V10L15.9733 2.5L3.47327 10ZM8.47327 22.5V15.0013H10.9733V22.5H8.47327ZM14.7233 22.5V15.0013H17.2233V22.5H14.7233ZM23.4733 22.5H20.9733V15.0013H23.4733V22.5ZM18.4733 10C18.4732 10.3284 18.4084 10.6535 18.2827 10.9569C18.1569 11.2603 17.9727 11.5359 17.7404 11.768C17.5081 12.0002 17.2324 12.1843 16.929 12.3099C16.6256 12.4355 16.3004 12.5001 15.972 12.5C15.6436 12.4999 15.3185 12.4352 15.0151 12.3094C14.7118 12.1837 14.4361 11.9994 14.204 11.7671C13.9718 11.5349 13.7877 11.2592 13.6621 10.9557C13.5365 10.6523 13.4719 10.3271 13.472 9.99875C13.4722 9.33554 13.7358 8.69957 14.2049 8.23072C14.6739 7.76188 15.3101 7.49858 15.9733 7.49875C16.6365 7.49892 17.2725 7.76253 17.7413 8.23161C18.2101 8.70068 18.4734 9.33679 18.4733 10Z",
    fill: "url(#paint0_linear_1_1561)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_1561",
    x1: 15.9733,
    y1: 2.5,
    x2: -8.02673,
    y2: 78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#027E8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#027E8A",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxsBank);
export default __webpack_public_path__ + "static/media/bxs-bank.9b2ab72bd90824fbcc4c6b395160a26c.svg";
export { ForwardRef as ReactComponent };